
const flagStr = `@#12vBeghEAAa*!*!#@&`;

export default {
  data() {
    return {
      emailText: {
        content: '',
        title: '',
      },
      defaultEmailData: null,
    }
  },


  methods: {
    startTranslate(type) {
      type = type || this.language
      if (!this.defaultEmailData) {
        return
      }
      if (type === 'origin') {
        this.emailText = {
          ...this.defaultEmailData
        }
      } else {
        let { needTrasArr, tempContentStr } = this.getNeedTranslateArr(type)
        this.translateText(type, needTrasArr, (data) => { this.setEmailText(tempContentStr, data) })
      }
    },

    trimStr(ostr, type) {

      // 去除空格和其他实体字符,如果无其他内容，则不用翻译
      let textStr = ostr.replace(/\s|\n|\r|&nbsp;|&amp;|&lt;|&gt;|&quot;/g, "")
      if (textStr.length < 1) {
        return ''
      }

      // 中文翻英文时如果没有中文，则不用翻译
      if (type === 'en' && !/[\u4E00-\u9FA5]/mg.test(textStr)) {
        return ''
      }

      // 英文翻中文,如果英文数量少于2，则不用翻译
      if (type === 'zh-cn') {
        const letters = textStr.match(/[A-Za-z]/mg)
        const len = letters ? letters.length : 0
        if (len < 2) {
          return ''
        }
      }

      // 要翻译的内容去除换行（换行符会影响翻译的结果）
      return ostr.replace(/\n|\r/g, "")
    },

    // 翻译文本
    getNeedTranslateArr(type) {
      const { title, content } = this.defaultEmailData
      // 需要翻译的内容数据，标题做为默认第一项
      const needTrasArr = [title.replace(/\n|\r/g, "") || '无主题']
      let tempContentStr = content
      let n = 0
      const that = this
      // 获取标签中的内容（style除外）
      tempContentStr = tempContentStr.replace(/\<(?!style\b)[^>]*\>(([^<])*)/g, function () {
        // 去除空格和其他实体字符
        let arg1 = that.trimStr(arguments[1], type)
        if (arg1) {
          // 符合要要翻译的字符串加入数组中
          needTrasArr.push(arg1);
          // 用AAA+数组索引+AAA替换掉原字符串中的内容，用于翻译后的内容还原
          let replaceStr = arguments[0].replace(arguments[1], flagStr + n + flagStr)
          n++;
          return replaceStr
        }
        return arguments[0];
      });

      return { needTrasArr, tempContentStr }
    },

    getTraslatedContent(tempContentStr, resultData) {
      // 去除翻译结果数组中的第一个元素，即标题
      const contentArr = resultData.slice(1)
      // 翻译后的内容还原到原文中
      let replaceHTML = this.replaceHTML(tempContentStr, contentArr)

      // 保存翻译结果到emailData中
      return {
        title: resultData[0],
        content: replaceHTML
      }

    },

    // 翻译后的内容还原到原文中
    replaceHTML(str, arr) {
      let strCopy = str
      arr.forEach((item, index) => {
        // 翻译时会把实体字符如&lt;中的分号换成中文；这里还原回来
        let tempItem = item.replace(/；/g, ';')
        strCopy = strCopy.replace(`${flagStr}${index}${flagStr}`, tempItem)
      })
      return strCopy
    }
  }
};